import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import ClientToken from '../../api/client-token';

// initial state
const state = {
    ipLocation: null,
    apiKey: 'AIzaSyCc3pdHDNXTAQAIUBD1EmbYVNAh7k9pja8'
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getIpLocation({ commit, rootState }, { cb }) {
        fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${state.apiKey}`, 
            { method: 'POST' }
        ).then(res => res.json())
        .then((payload) => {
            cb(payload.location);
        });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
